import { apiFetch } from '@/shared/api/client'

/** Baris material pada respons today/detail dispatch (§3.3 warehouse-gudang-api.md). */
export type DispatchLineItem = {
  id: string
  material_id: string
  material_code: string
  material_name: string
  uom: string
  qty: number
}

/** Satu dispatch outgoing pada GET /warehouse/dispatches/today. */
export type DispatchListItem = {
  id: string
  code: string
  target_kitchen_name: string
  warehouse_delman_name: string
  status: 'draft' | 'dispatched' | 'in_transit' | 'receiving_draft' | 'receiving_completed' | 'cancelled' | string
  updated_at: string
  dispatched_at?: string
  lines: DispatchLineItem[]
}

type TodayDispatchesResponse = { outgoing: DispatchListItem[] }

/** GET /warehouse/dispatches/today. */
export async function fetchTodayDispatches(): Promise<DispatchListItem[]> {
  const res = await apiFetch<TodayDispatchesResponse>('/warehouse/dispatches/today')
  return res.outgoing ?? []
}

export type DispatchLineInput = {
  materialId: string
  uom: string
  qty: number
}

export type DispatchSavePayload = {
  targetKitchenId: string
  warehouseDelmanUserId: string
  lines: DispatchLineInput[]
}

export type DispatchSaveResponse = {
  dispatch_id: string
  dispatch_code: string
  updated_at: string
}

function toRequestBody(payload: DispatchSavePayload, pin: string) {
  return {
    target_kitchen_id: payload.targetKitchenId,
    warehouse_delman_user_id: payload.warehouseDelmanUserId,
    lines: payload.lines.map((l) => ({ material_id: l.materialId, uom: l.uom, qty: l.qty })),
    pin,
  }
}

/** POST /warehouse/dispatches/{ref}/save — draft, HEAD & STAFF boleh, tidak wajib PIN. */
export async function saveDispatch(ref: string, payload: DispatchSavePayload): Promise<DispatchSaveResponse> {
  return apiFetch<DispatchSaveResponse>(`/warehouse/dispatches/${encodeURIComponent(ref)}/save`, {
    method: 'POST',
    body: JSON.stringify(toRequestBody(payload, '')),
  })
}

export type DispatchActionResponse = {
  dispatch_id: string
  dispatch_code: string
  updated_at: string
}

/** POST /warehouse/dispatches/{ref}/dispatch — wajib HEAD_WAREHOUSE + PIN (§3.5/§4.3). */
export async function dispatchToDelman(
  ref: string,
  payload: DispatchSavePayload,
  pin: string,
): Promise<DispatchActionResponse> {
  return apiFetch<DispatchActionResponse>(`/warehouse/dispatches/${encodeURIComponent(ref)}/dispatch`, {
    method: 'POST',
    body: JSON.stringify(toRequestBody(payload, pin)),
  })
}
